/**
 * Chart.js legend onClick handlers that "isolate on click":
 * clicking a legend item keeps only that item visible;
 * clicking the same item again restores all items.
 */

export function legendIsolateClickPie(_evt: any, legendItem: any, legend: any) {
  const index = legendItem.index as number;
  const chart = legend.chart;
  const meta = chart.getDatasetMeta(0);
  const visibleCount = (meta.data as any[]).filter((d) => !d.hidden).length;
  const isOnlyThis = visibleCount === 1 && !meta.data[index].hidden;
  (meta.data as any[]).forEach((d, i) => {
    d.hidden = isOnlyThis ? false : i !== index;
  });
  chart.update();
}

export function legendIsolateClickDataset(_evt: any, legendItem: any, legend: any) {
  const idx = legendItem.datasetIndex as number;
  const chart = legend.chart;
  const n: number = chart.data.datasets.length;
  const visibleCount = Array.from({ length: n }, (_, i) => i).filter(
    (i) => !chart.getDatasetMeta(i).hidden
  ).length;
  const isOnlyThis = visibleCount === 1 && !chart.getDatasetMeta(idx).hidden;
  Array.from({ length: n }, (_, i) => i).forEach((i) => {
    chart.getDatasetMeta(i).hidden = isOnlyThis ? false : i !== idx;
  });
  chart.update();
}
